import React, {
    createContext,
    PropsWithChildren,
    useCallback, useEffect,
    useState,
} from "react";

type LayoutContextType = {
    windowWidth: number;
    setWindowWidth: React.Dispatch<React.SetStateAction<number>>;
  headerHidden: boolean;
  setHeaderHidden: (headerHidden: boolean) => void;
  footerHidden: boolean;
  scribeHidden: boolean;
  setScribeHidden: (scribeHidden: boolean) => void;
  setFooterHidden: (footerHidden: boolean) => void;
  firstLayerHidden: boolean;
  setFirstLayerHidden: (footerLoaded: boolean) => void;
  secondLayerHidden: boolean;
  setSecondLayerHidden: (footerLoaded: boolean) => void;
  firstLayerHomeHidden: boolean;
  setFirstLayerHomeHidden: (footerLoaded: boolean) => void;
  secondLayerHomeHidden: boolean;
  setSecondLayerHomeHidden: (footerLoaded: boolean) => void;
    shouldInfoFadeOut: boolean;
    setShouldInfoFadeOut : (shouldInfoFadeOut: boolean) => void;
  headerLoaded: boolean;
  setHeaderLoaded: (headerLoaded: boolean) => void;
  footerLoaded: boolean;
  setFooterLoaded: (footerLoaded: boolean) => void;
  showQrAnimation: boolean;
  setShowQrAnimation: (showQrAnimation: boolean) => void;
    cardVisibilityFade: boolean; setCardVisibilityFade: (cardFadeIn:boolean )=> void;
    cardReady: boolean;
    setCardReady: (cardReady:boolean) => void;
  isPaused: boolean;
  setIsPaused: (isPaused: boolean) => void;

  reset: VoidFunction;

};

const LayoutContext = createContext<LayoutContextType>({
    windowWidth: window.innerWidth,
    setWindowWidth: () => {},
  headerHidden: true,
  setHeaderHidden: (headerHidden: boolean) => {},
  footerHidden: true,
  setFooterHidden: (footerHidden: boolean) => {},
  scribeHidden: true,
  setScribeHidden: (scribeHidden: boolean) => {},
  firstLayerHidden: false,
  setFirstLayerHidden: (footerLoaded: boolean) => {},
  secondLayerHidden: false,
  setSecondLayerHidden: (footerLoaded: boolean) => {},
  firstLayerHomeHidden: true,
  setFirstLayerHomeHidden: (footerLoaded: boolean) => {},
  secondLayerHomeHidden: true,
  setSecondLayerHomeHidden: (footerLoaded: boolean) => {},
    shouldInfoFadeOut: false,
    setShouldInfoFadeOut: (shouldInfoFadeOut: boolean) => {},
  headerLoaded: false,
  setHeaderLoaded: (headerLoaded: boolean) => {},
  footerLoaded: false,
  setFooterLoaded: (footerLoaded: boolean) => {},
  showQrAnimation: false,
  setShowQrAnimation: (showQrAnimation: boolean) => {},
    cardVisibilityFade:false,
  setCardVisibilityFade: (cardFadeIn: boolean) => {},
    cardReady: false,
    setCardReady: (cardReady: boolean) => {},
  isPaused: false,
  setIsPaused: (isPaused: boolean) => {},
  reset: () => {},

});

const LayoutContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [headerHidden, setHeaderHidden] = useState<boolean>(true);
  const [footerHidden, setFooterHidden] = useState<boolean>(true);
  const [scribeHidden, setScribeHidden] = useState<boolean>(true);
  const [firstLayerHidden, setFirstLayerHidden] = useState<boolean>(false);
  const [secondLayerHidden, setSecondLayerHidden] = useState<boolean>(false);
  const [firstLayerHomeHidden, setFirstLayerHomeHidden] = useState<boolean>(true);
  const [secondLayerHomeHidden, setSecondLayerHomeHidden] = useState<boolean>(true);
    const [shouldInfoFadeOut, setShouldInfoFadeOut] = useState(false);

  const [headerLoaded, setHeaderLoaded] = useState<boolean>(false);
  const [footerLoaded, setFooterLoaded] = useState<boolean>(false);
  const [showQrAnimation, setShowQrAnimation] = useState<boolean>(false);
    const [cardFadeIn, setCardFadeIn] = useState(false); // Stato per gestire il fadein
    const [cardReady, setCardReady] = useState(false); // Stato per gestire il fadein

  const [isPaused, setIsPaused] = useState<boolean>(false);

  const reset = useCallback(() => {
    setHeaderHidden(true);
    setFooterHidden(true);
    setScribeHidden(true);
    setFirstLayerHidden(false);
    setSecondLayerHidden(false);
    setFirstLayerHomeHidden(true);
    setSecondLayerHomeHidden(true);
    setShouldInfoFadeOut(false);
    setHeaderLoaded(false);
    setFooterLoaded(false);
    setShowQrAnimation(false);
    setCardFadeIn(false);
    setCardReady(false);
    setIsPaused(false);
  }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

  return (
    <LayoutContext.Provider
      value={{
          windowWidth,
          setWindowWidth,
        headerHidden,
        setHeaderHidden,
        footerHidden,
        setFooterHidden,
        scribeHidden,
        setScribeHidden,
        firstLayerHidden,
        setFirstLayerHidden,
        secondLayerHidden,
        setSecondLayerHidden,
        firstLayerHomeHidden,
        setFirstLayerHomeHidden,
        secondLayerHomeHidden,
        setSecondLayerHomeHidden,
          shouldInfoFadeOut , setShouldInfoFadeOut,
        headerLoaded,
        setHeaderLoaded,
        footerLoaded,
        setFooterLoaded,
        showQrAnimation,
        setShowQrAnimation,
          cardVisibilityFade: cardFadeIn, setCardVisibilityFade: setCardFadeIn, cardReady, setCardReady,
        isPaused,
        setIsPaused,
        reset,

      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

const useLayoutContext = () => React.useContext(LayoutContext);

export { LayoutContext, LayoutContextProvider, useLayoutContext };
